/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationInboxViewDto { 
    id: string;
    avatarUrl: string;
    statusType: object;
    /**
     * Internationalized text that resolves to a string
     */
    title: string;
    /**
     * Internationalized text that resolves to a string
     */
    message: string;
    timestamp: string;
    isUnread: boolean;
    senderName?: string;
    category: object;
    action: object;
}

